module.exports = __webpack_public_path__ + "static/header-b9bfeab68b01e33d66796510884f569f.gif";